module.exports = { 
    DIVIDER_HEIGHT : `2.5px`    
}